import { Button, Modal } from 'react-daisyui';
import { useModalsContext } from '../../../ModalsProvider/Modals.context';
import { useUserContext } from '../../../UserProvider/User.context';
import { eUserRole } from '../../../UserProvider/User.enums';
import { useSubscriptionContext } from '../../Subscription.context';
import { useNavigate } from 'react-router-dom';
import { RouterPaths } from '../../../../components/Router/Router.constants';
import { SettingsTabs } from '../../../../pages/Settings/Settings.enum';
import { useTranslation } from 'react-i18next';
import './SubscriptionModals.styles.scss';

export default function NoPaidModal(): React.ReactElement {
  const { t } = useTranslation('settings/subscriptionsModals');
  const { toggleNoPaidModal, showNoPaidModal } = useModalsContext();
  const { currentUser, currentUserRole } = useUserContext();
  const { markNotificationAsRead } = useSubscriptionContext();
  const navigate = useNavigate();

  const isOwner = currentUserRole === eUserRole.OWNER;

  return (
    <Modal open={showNoPaidModal} backdrop={false}>
      <Modal.Header>{t('noPaidModal.title')}</Modal.Header>

      <Modal.Body className="NoPaidModal__content">
        <p className="NoPaidModal__icon">🥶</p>
        <p>{t('noPaidModal.greeting', { name: currentUser?.name })}</p>
        <p className="font-bold">{t('noPaidModal.suspended')}</p>
        <p className="text-center">{t('noPaidModal.body')}</p>
      </Modal.Body>

      {isOwner && (
        <Modal.Actions className="NoPaidModal__actions">
          <Button
            color="primary"
            onClick={() => {
              markNotificationAsRead();
              navigate(`${RouterPaths.settings}?section=${SettingsTabs.SUBSCRIPTION}`);
              toggleNoPaidModal(false);
            }}
          >
            {t('noPaidModal.button')}
          </Button>
        </Modal.Actions>
      )}
    </Modal>
  );
}
